/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProgrammeStatus {
    JOINER = 'JOINER',
    HOLDER = 'HOLDER',
    LEAVER = 'LEAVER',
    INACTIVE = 'INACTIVE',
}
